import $ from 'jquery'
import 'rangeslider.js'

import { selectors } from '../selectors'
import { $elementIsVisible } from '../shared'
import { setAmountCookies } from '../cookies'
import { formatNumberAndCurrency } from './formater'
import { renderLoanInfoTable, renderPaymentCalendar } from './table'

// https://rangeslider.js.org/

// Wrappers
export const AMOUNTS = [{ selector: selectors.sliders.amountWrapper }]
export const INSTALLMENTS = [{ selector: selectors.sliders.installmentsOfferpage }, { selector: selectors.sliders.installmentsCalculator }, { selector: selectors.sliders.installmentsHomepage }]

// + elementIsVisible...
export default () => {
    AMOUNTS.map((wrapper) => {
        $(wrapper.selector).each((_, element) => {
            $elementIsVisible($(element)) && initRangeSlider($(element))
        })
    })

    INSTALLMENTS.map((wrapper) => {
        $(wrapper.selector).each((_, element) => {
            $elementIsVisible($(element)) && initCarouselSelector($(element))
        })
    })
}

// ----------------------- Sliders -----------------------

const initRangeSlider = ($wrapper) => {
    let $slider = $wrapper.find(selectors.sliders.input)
    let $increment = $wrapper.find(selectors.sliders.incrementButton)
    let $decrement = $wrapper.find(selectors.sliders.decrementButton)

    $slider
        .rangeslider({
            polyfill: false,
            onInit: () => updateHandleAmount($wrapper.find(selectors.sliders.handle), $slider.val()),
            onSlideEnd: () => {},
        })
        .on('input', () => updateHandleAmount($wrapper.find(selectors.sliders.handle), $slider.val()))
        .on('change', () => {})

    const shiftRangeSlider = (stepMethod) => {
        $slider[0][stepMethod](1)
        $slider.trigger('change')
    }

    $increment.on('click', shiftRangeSlider.bind(null, 'stepUp'))
    $decrement.on('click', shiftRangeSlider.bind(null, 'stepDown'))
}

const initCarouselSelector = ($wrapper) => {
    $wrapper.on('carouselChange', (e) => {
        updateHandleInstallments(e.detail.value)
    })
}

const updateHandleAmount = ($handle, amountValue) => {
    $handle.html(formatNumberAndCurrency(amountValue)) // Set updated handle text

    renderLoanInfoTable() // Recalculate LoanInfo table
    renderPaymentCalendar() // Recalculate Payment calendar

    setAmountCookies(amountValue)
}

const updateHandleInstallments = () => {
    renderLoanInfoTable() // Recalculate LoanInfo table
    renderPaymentCalendar() // Recalculate Payment calendar
}
